import { GetDataForThanksForRSVPQuery } from '@graphql/generated';
import { useTranslation } from '@shared/core';
import { useQueryParamHelper } from '@shared/core/queryString';
import useLoadGoogleFont from '@apps/saveTheDate/hooks/useLoadGoogleFont';

export const useHeaderController = (queryData?: GetDataForThanksForRSVPQuery) => {
  const fontFamily = queryData?.eventByName?.eventDesign?.font?.fontFamily ?? 'PT Serif';
  const fontTextTransform = queryData?.eventByName?.eventDesign?.font?.textTransform ?? 'none';
  useLoadGoogleFont([`${fontFamily}:400`]);
  const { t } = useTranslation('thanksForRSVP');
  const tCongratulationsCard = t('congratulationsCard');
  const { getValueString } = useQueryParamHelper();
  const coupleNames = queryData?.eventByName?.info?.eventDisplayName || tCongratulationsCard.theCouple();
  const location = getValueString('location');
  const date = getValueString('date');

  return {
    coupleNames,
    location,
    date,
    fontFamily,
    fontTextTransform,
    tCongratulationsCard,
  };
};
